import { FC, ReactNode, Suspense, useEffect } from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";
import { useTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { ToastMessageProvider } from "@context";
import { enUS } from "@mui/x-date-pickers/locales";
import { RecoilRoot } from "recoil";
import { ToastProvider } from "@context/ToastContext";
import { ConfigProvider } from "antd";
import { APIProvider } from '@vis.gl/react-google-maps';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PostHogWrapper from "../components/PostHogWrapper";
import { GathernTokenGuard } from "../components/GathernTokenGuard";

const mode = import.meta.env.VITE_MODE ?? "not-found";
const dir = {
  ar: "rtl",
  en: "ltr",
};


const ENABLE_POSTHOG = import.meta.env.VITE_MODE === "PROD"
export const AllProviders: FC<{ children: ReactNode }> = ({ children }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });

  const {
    i18n: { language, changeLanguage },
  } = useTranslation();

  const direction = dir[(language as "ar" | "en") ?? "ar"];

  useEffect(() => {
    document.body.dir = direction;
  }, [language]);

  const Ribbon = () => (
    <>
      {/* {mode === "DEV" && (
        <div
          className={
            "text-white text-xl py-1 fixed w-[400px] flex items-center " +
            "justify-center bg-primary top-2 -right-44 rotate-[45deg] z-[2000] pointer-events-none opacity-75"
          }
        >
          Demo
        </div>
      )} */}
    </>
  );

  const Wrapper: FC<{ children: ReactNode }> = ({ children }) => {
    return <>{children}</>;
  };


  return (
    <Suspense fallback={<></>}>
      <HelmetProvider>
        <RecoilRoot>
          <PostHogWrapper 
            enabled={ENABLE_POSTHOG}
          >
            <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
              <Wrapper>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                  <ThemeProvider theme={{ ...theme, direction }}>
                    <ConfigProvider
                      theme={{
                        components: {
                          DatePicker: {
                            activeBorderColor: "#5B3FFF",
                            colorPrimary: "#5B3FFF",
                          },
                          Slider: {
                            dotActiveBorderColor: "#5B3FFF",
                            dotBorderColor: "#5B3FFF",
                            handleColor: "#5B3FFF",
                            colorBgElevated: "#5B3FFF",
                            handleSize: 13,
                          },
                        },
                      }}
                    >
                      <ToastProvider>
                        <ToastMessageProvider>
                          <QueryClientProvider client={queryClient}>
                            <GathernTokenGuard>
                              <CssBaseline />
                              {<Ribbon />}
                              {children}
                            </GathernTokenGuard>
                          </QueryClientProvider>
                        </ToastMessageProvider>
                      </ToastProvider>
                    </ConfigProvider>
                  </ThemeProvider>
                </LocalizationProvider>
              </Wrapper>
            </APIProvider>
          </PostHogWrapper>
        </RecoilRoot>
      </HelmetProvider>
    </Suspense>
  );
};
